import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { DeleteRegular } from "@fluentui/react-icons";
import i18n from "i18next";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import { IUserBedarfPosition } from "../../../Models/IUserBedarfPosition";

interface IDialogDeleteBedarfe {
  onDelete(): void;
  onDismiss(): void;
  open: boolean;
  itemsToDelete?: string[];
}

function DialogDeleteBedarfe(props: IDialogDeleteBedarfe) {
  const deleteItems = () => {
    if (props.itemsToDelete) {
      fetchWrapper
        .postWithAuth(`${baseUrl}/api/userbedarfe/delete`, props.itemsToDelete)
        .then((data: any) => {
          props.onDismiss();
          props.onDelete();
        });
    }
  };
  return (
    <Dialog open={props.open}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{i18n.t<string>("deleteBedarfe")}</DialogTitle>
          <DialogContent>{i18n.t<string>("deleteBedarfeText")}</DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={() => {
                deleteItems();
              }}
              icon={<DeleteRegular />}
            >
              {i18n.t<string>("delete")}
            </Button>
            <Button onClick={() => props.onDismiss()}>
              {i18n.t<string>("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default DialogDeleteBedarfe;
